import React, {PureComponent} from 'react';
import LineChart from "../independentComponents/graphComponent";
import $ from "jquery";
import {confirmIdentity} from "../functions/api";
import Overlay from "ol/Overlay";
import {fromLonLat} from "ol/proj";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import Alert from "react-s-alert";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Feature from "ol/Feature";
import LineString from "ol/geom/LineString";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import parallel from "async/parallel";

import marshallIcon from "../../img/marshall.png";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

// Create a pattern, offscreen
const patternCanvas = document.createElement('canvas');
const patternContext = patternCanvas.getContext('2d');
// Give the pattern a width and height of 50
patternCanvas.width = 50;
patternCanvas.height = 50;

class PopoutFlagIssueDetail extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            telemetryData: null,
            orderedMetrics: [],
        };

        this.getTelemetry = this.getTelemetry.bind(this);
        this.getMapElements = this.getMapElements.bind(this);
        this.updateShow = this.updateShow.bind(this);
        this.setupMap = this.setupMap.bind(this);
        this.setupPolyline = this.setupPolyline.bind(this);
        this.sortMetrics = this.sortMetrics.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $(".loading").fadeIn();
        const helper = this;
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, () => {
            parallel([
                function (callback) {
                    helper.getMapElements((status) => {
                        callback(null, status);
                    });
                },
                function (callback) {
                    helper.getTelemetry((status) => {
                        callback(null, status);
                    });
                }
            ], function (err, result) {
                helper.sortMetrics();
                $(".loading").fadeOut();
            });
        });
    }

    /* GET DATA */
    setupMap(flagVisuals) {
        this.map = new Map({
            target: "map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([parseFloat(this.props.match.params.mapCenterLng), parseFloat(this.props.match.params.mapCenterLat)]),
                zoomFactor: 1.1,
                zoom: parseInt(this.props.match.params.mapZoomLevel) - 2,
                maxZoom: 141,
                rotation: parseFloat(this.props.match.params.mapRotation),
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        const innerDiv = $('' +
            '<div id="car_id_marker">' +
            '   <span class="fa-stack carPin">' +
            '       <i class="fa fa-circle fa-stack-2x" style="color: #b00b0d;line-height: inherit"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
            '   </span>' +
            '</div>').get(0);

        this.setState({
            marker: new Overlay({
                id: "carMarker_Details",
                element: innerDiv,
                position: fromLonLat([0, 0]),
                offset: [0, 10],
                positioning: 'bottom-center',
            })
        }, () => {
            this.map.addOverlay(this.state.marker);
            this.setupPolyline(flagVisuals);
        });
    }

    setupPolyline(sessionStatus) {

        let featureArr = [];
        for (let post = 0; post < sessionStatus.length; post++) {

            // Parse Polyline points
            let temp = JSON.parse(sessionStatus[post].post.polyline);

            // Add marker of post
            const innerDiv = $('' +
                '<div class="marshallFlag w3-animate-fading">' +
                '   <span id= "marshall_' + sessionStatus[post].post.id + '" class="sectorText">' + sessionStatus[post].post.name + ' </span>' +
                '   <img style="height: 100%; width:100%" src="' + marshallIcon + '" alt="sector"/>' +
                '</div>'
            ).get(0);

            let marshallPost = new Overlay({
                element: innerDiv,
                position: fromLonLat([temp[0].lng, temp[0].lat]),
                offset: [-2, 4],
                positioning: 'bottom-left',
            });

            this.map.addOverlay(marshallPost);

            // Add polyline
            let coords = [];
            for (let c = 0; c < temp.length; c++) {
                coords.push(fromLonLat([temp[c].lng, temp[c].lat]));
            }

            let style = null;
            if (sessionStatus[post].flag.second_color) {
                let color1 = sessionStatus[post].flag.first_color;
                let color2 = sessionStatus[post].flag.second_color;
                let numberOfStripes = 50;
                for (let x = 0; x < numberOfStripes * 2; x++) {
                    let thickness = 300 / numberOfStripes;
                    patternContext.beginPath();
                    patternContext.strokeStyle = x % 2 ? color1 : color2;
                    patternContext.lineWidth = thickness;
                    patternContext.lineCap = 'round';

                    patternContext.moveTo(x * thickness + thickness / 2 - 300, 0);
                    patternContext.lineTo(x * thickness + thickness / 2, 300);
                    patternContext.stroke();
                }

                // Create our primary canvas and fill it with the pattern
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const pattern = ctx.createPattern(patternCanvas, 'repeat');
                ctx.fillStyle = pattern;
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                style = new Style({
                    stroke: new Stroke({
                        lineCap: "round",
                        lineJoin: "round",
                        width: 9,
                        color: pattern,
                    }),
                });
            } else {
                style = new Style({
                    stroke: new Stroke({
                        lineCap: "round",
                        lineJoin: "round",
                        width: 9,
                        color: sessionStatus[post].flag.first_color,
                    }),
                });
            }
            let feature = new Feature({
                geometry: new LineString(coords),
                name: 'Line',
            });
            feature.setStyle(style);
            featureArr.push(feature);
        }

        let layerLines = new VectorLayer({
            name: "sectors",
            className: "dash_map_sectors",
            source: new VectorSource({
                features: featureArr
            }),
        });
        this.map.addLayer(layerLines);
    }

    getTelemetry(callback) {
        $(".loading").fadeIn();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getFlagIssueTelemetry',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                issue: helper.props.match.params.issue,
                clear: helper.props.match.params.clear,
                sessionID: helper.props.match.params.sessionID,
                eventID: helper.props.match.params.eventID,
                carID: helper.props.match.params.carID,
                issueID: helper.props.match.params.issueID,
            },
            success: function (data) {
                if (data !== undefined && Object.keys(data).length > 0) {
                    helper.setState({
                        telemetryData: data,
                    }, () => {
                        callback("ok");
                    });
                } else {
                    $(".loading").fadeOut();
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("noFlagTelemetry") + '</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 15000,
                        offset: 150
                    });
                    callback("nok");
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getMapElements(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getFlagIssueVisualElements',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                issueID: helper.props.match.params.issueID,
            },
            success: function (data) {
                helper.setupMap(data);
                callback("ok");
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    updateShow(index) {

        let ratio = (Math.round((this.state.telemetryData.data[this.state.speedTag][index] / (this.state.telemetryData.data[this.state.rpmTag][index] / 1000)) * 10) / 10).toFixed(1);

        this.state.marker.setPosition(
            fromLonLat([
                this.state.telemetryData.data.coords[index][0],
                this.state.telemetryData.data.coords[index][1]
            ])
        );

        this.setState({
            ratio: (isNaN(ratio) ? 0 : ratio),
            timestamp: this.state.telemetryData.timestamp[index],
        });
    }

    sortMetrics() {
        if (this.state.telemetryData) {
            let array = [];
            for (let i = 0; i < Object.keys(this.state.telemetryData.labels).length; i++) {
                array[this.state.telemetryData.labels[Object.keys(this.state.telemetryData.labels)[i]].order_no] = Object.keys(this.state.telemetryData.labels)[i];
            }
            let filtered = array.filter(function (el) {
                return el != null;
            });

            Object.keys(this.state.telemetryData.labels).forEach((tag) => {
                if (this.state.telemetryData.labels[tag].en.indexOf("RPM") >= 0) {
                    this.setState({
                        rpmTag: tag,
                    });
                }
                if (this.state.telemetryData.labels[tag].en.indexOf("Speed") >= 0) {
                    this.setState({
                        speedTag: tag,
                    });
                }
            });

            this.setState({
                orderedMetrics: filtered,
            });
        }
    }

    /* RENDER */
    render() {
        return (
            <div className={"container-fluid"} style={{margin: 10, padding: 0}}>
                <Alert stack={{limit: 10}} html={true}/>
                <div className={"loading"}>
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                <div className={"row w3-animate-fading"} style={{margin: 10}}>
                    {this.state.header}
                    <div className={"col-xs-12 col-sm-12 col-md-offset-1 col-md-10"}>
                        <div style={{
                            marginLeft: 15,
                            height: 350,
                        }} id={"map"}/>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"w3-animate-fading"} style={{height: "100%"}}>
                        <span className={"App_raceLength vcenter"}>{this.state.telemetryData ? this.state.timestamp : "---"}</span>
                    </div>
                </div>
                {this.state.telemetryData ? (
                    this.state.orderedMetrics.map((tag) => {
                        if (this.state.telemetryData.maxes[tag] > 0) {
                            return (
                                <div key={"graph_" + tag} className={"col-md-12"} style={{padding: 0, width: "100%"}}>
                                    <LineChart
                                        dataName={this.state.telemetryData.labels[tag][localStorage.getItem("i18nextLng")]}
                                        thresholdCode60={this.state.telemetryData.labels[tag].en.toUpperCase().includes("SPEED") ? this.props.match.params.speedThreshold : undefined}
                                        data={this.state.telemetryData.data[tag]}
                                        additionalData={this.state.telemetryData.labels[tag].en === "RPM" ? this.state.ratio : false}
                                        hoverTriggerIndex={[true, false]}
                                        minYAxis={this.state.telemetryData.labels[tag].unit === "%" ? 0 : 0}
                                        maxYAxis={this.state.telemetryData.labels[tag].unit === "%" ? 100 : this.state.telemetryData.maxes[tag]}
                                        unit={this.state.telemetryData.labels[tag].unit}
                                        updateShow={this.updateShow}
                                    />
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })
                ) : null}
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutFlagIssueDetail));
